import { getLocale } from "../runtime";

const sv_changelang = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Byt språk`
};

const changelang = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_changelang(inputs)
	return "changeLang";
};

export { changelang as "changeLang" };